/**
 * Diálogo de confirmación reutilizable (mismo criterio visual que el panel admin).
 */
import { useId, type ReactNode } from 'react';
import styles from './ConfirmDialog.module.css';

export interface ConfirmDialogProps {
    open: boolean;
    title: string;
    onCancel: () => void;
    onConfirm: () => void | Promise<void>;
    children: ReactNode;
    confirmLabel?: string;
    cancelLabel?: string;
}

export default function ConfirmDialog({
    open,
    title,
    onCancel,
    onConfirm,
    children,
    confirmLabel = 'Eliminar',
    cancelLabel = 'Cancelar',
}: ConfirmDialogProps) {
    const titleId = useId();

    if (!open) {
        return null;
    }

    return (
        <div className={styles.modalOverlay} onClick={onCancel} role="presentation">
            <div
                className={styles.modalBox}
                onClick={e => e.stopPropagation()}
                role="alertdialog"
                aria-modal="true"
                aria-labelledby={titleId}
            >
                <p id={titleId} className={styles.modalTitle}>
                    {title}
                </p>
                <div className={styles.modalMessage}>{children}</div>
                <div className={styles.modalActions}>
                    <button type="button" className={`${styles.modalBtn} ${styles.modalCancelBtn}`} onClick={onCancel}>
                        {cancelLabel}
                    </button>
                    <button type="button" className={`${styles.modalBtn} ${styles.modalDeleteBtn}`} onClick={onConfirm}>
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}
